module.exports = __webpack_public_path__ + "img/card-marked.3e257d11.jpg";